module.exports = __webpack_public_path__ + "static/media/MIF.2f35881a.jpg";